export default function isObject(x) {
  return !!x && (typeof x === 'object' || typeof x === 'function');
}
